import api from './api';

// همهٔ endpoint‌های پنل ادمین (read-only، گارد شده با get_current_admin در بک‌اند).
// api instance به‌طور خودکار Authorization Bearer را از localStorage اضافه می‌کند.
export const adminApi = {
  overview: (days = 30) =>
    api.get('/api/admin/overview', { params: { days } }).then((r) => r.data),
  dailyMetrics: (days = 30) =>
    api.get('/api/admin/daily-metrics', { params: { days } }).then((r) => r.data),
  users: (q = '', limit = 50) =>
    api.get('/api/admin/users', { params: { q: q || undefined, limit } }).then((r) => r.data),
  user: (id) =>
    api.get(`/api/admin/users/${id}`).then((r) => r.data),
  products: (days = 30, limit = 100) =>
    api.get('/api/admin/products', { params: { days, limit } }).then((r) => r.data),
  competitors: (days = 30, limit = 100) =>
    api.get('/api/admin/competitors', { params: { days, limit } }).then((r) => r.data),
  rules: (limit = 50) =>
    api.get('/api/admin/rules', { params: { limit } }).then((r) => r.data),
  priceHistory: (days = 30) =>
    api.get('/api/admin/price-history', { params: { days } }).then((r) => r.data),
  distribution: () =>
    api.get('/api/admin/distribution').then((r) => r.data),
  scheduler: (days = 7, limit = 30) =>
    api.get('/api/admin/scheduler', { params: { days, limit } }).then((r) => r.data),
  recentActivity: (days = 30, limit = 20) =>
    api.get('/api/admin/recent-activity', { params: { days, limit } }).then((r) => r.data),
  health: () =>
    api.get('/api/admin/health').then((r) => r.data),
};

export default adminApi;
